import * as mapInventory from "./global/modules/map-inventory_wp";
mapInventory.init();
